import { Record as ImmutableRecord } from 'immutable';
export default class ValidationError extends ImmutableRecord({
  actionId: null,
  flowValidationErrorType: null,
  message: '',
  validationScope: null,
  contextMap: {}
}, 'ValidationError') {}